import React from "react";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  return <footer className="bg-background-dark text-foreground-dark pt-12 pb-8 md:pt-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14">
          {/* Brand */}
          <div className="space-y-5">
            <div className="space-y-4">
              <img src="https://relaxed-fowl.10web.cloud/wp-content/uploads/2025/09/cropped-Mens-Health-Logo-1.png" alt="IronPeak Men's Health Logo" className="h-24 md:h-28 w-auto" />

              <p className="text-sm text-muted-foreground-dark leading-relaxed max-w-sm">
                Physician-led testosterone care for Texas men who want clear
                answers, responsible treatment, and ongoing medical oversight.
              </p>
            </div>

            <div className="space-y-3 text-sm text-muted-foreground-dark">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-primary flex-shrink-0" />
                <div>
                  <p>Founded in Prosper, Texas</p>
                  <p className="text-xs mt-1">
                    Telemedicine available statewide
                  </p>
                </div>
              </div>

              <a href="tel:4695575547" className="flex items-center gap-3 hover:text-foreground-dark transition-colors">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <span>(469) 557-5547</span>
              </a>

              <a href="mailto:Mike@ironpeakmenshealth.com" className="flex items-center gap-3 hover:text-foreground-dark transition-colors break-all">
                <Mail className="w-4 h-4 text-primary flex-shrink-0" />
                <span>Mike@ironpeakmenshealth.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-5">
            <h3 className="text-lg font-semibold text-foreground-dark">
              Quick Links
            </h3>

            <nav className="grid grid-cols-2 gap-x-6 gap-y-3 md:flex md:flex-col md:space-y-0">
              <Link to="/HomePage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Home
              </Link>

              <Link to="/PricingPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Pricing
              </Link>

              <Link to="/ServicesPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Services
              </Link>

              <Link to="/AboutUsPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                About Us
              </Link>

              <Link to="/ContactPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Contact
              </Link>

              <Link to="https://ironpeakmenshealth.com/learn/" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Learn
              </Link>
            </nav>
          </div>

          {/* Connect */}
          <div className="space-y-5">
            <h3 className="text-lg font-semibold text-foreground-dark">
              Connect With Us
            </h3>

            <p className="text-sm text-muted-foreground-dark leading-relaxed max-w-sm">
              Follow IronPeak for practical men’s health, TRT, metabolism, and
              performance education.
            </p>

            <div className="flex items-center gap-3">
              <Link to="https://www.instagram.com/ironpeakhealth" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
                <span className="sr-only">Instagram</span>
              </Link>

              <Link to="https://www.tiktok.com/@ironpeakhealth" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.95a8.16 8.16 0 0 0 4.78 1.52V7.03a4.85 4.85 0 0 1-1.01-.34Z" />
                </svg>
                <span className="sr-only">TikTok</span>
              </Link>
            </div>

            <div className="rounded-lg border border-white/10 bg-white/5 p-4">
              <p className="text-sm font-medium text-foreground-dark mb-1">
                Start With Basecamp TRT
              </p>
              <p className="text-xs text-muted-foreground-dark leading-relaxed">
                $150/month for qualified patients. Treatment only when
                medically appropriate after physician review.
              </p>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-muted-dark" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-muted-foreground-dark text-center md:text-left">
            © 2026 IronPeak Men's Health. All rights reserved.
          </p>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link to="/PrivacyPolicyPage" className="text-xs sm:text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
              Privacy Policy
            </Link>

            <Link to="/TermsOfServicePage" className="text-xs sm:text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}